import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import styles from './Day.module.css'

export function Day({ date }: { date: string }) {
  const intl = useIntl()
  return (
    <div className={styles.dayWrapper}>
      <Typography className={styles.weekday} variant="body-xs-regular-flat">
        {intl.formatDate(date, {
          weekday: 'long',
        })}
      </Typography>
      <Typography className={styles.dayAndMonth} variant="body-m-bold-flat">
        {intl.formatDate(date, {
          day: 'numeric',
          month: 'short',
        })}
      </Typography>
    </div>
  )
}
